import { render } from "./ContainerLayout.vue?vue&type=template&id=2f3a7d24"
import script from "./ContainerLayout.vue?vue&type=script&lang=js"
export * from "./ContainerLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__